/*
* PdfSpacingContent.js
* Created on 22-11-2017
* @author Olivier for &ranj
* 
* Empty content container used for creating spacing.
*/

import AbstractPdfContent from "./AbstractPdfContent";

export default class PdfSpacingContent extends AbstractPdfContent {
    constructor(width, height) {
        super();

        this.setWidth(width);
        this.setHeight(height);
    }
}